<template lang="pug">
button.linkServices.linkServices-button(type="button" @click="logout" v-if="isAuthenticated")
	.frame
	span.text Logout
router-link(:to="{name: 'connect'}", v-else-if="!isAuthenticated"): span Login
</template>

<script>
import Vue from 'vue'
import { EventBus } from 'Common/event-bus'
import { E24Event } from 'Common/e24-events'

export default {
	name: 'login-button',
	methods: {
		logout: function () {
			Vue.e24.security.logout().then((resp) => {
				// Same EventBus singleton nav-bar.vue listens on (both resolve
				// 'Common/event-bus' to the identical easytitle24-2.x-common
				// module within this bundle) -- tells it to re-check auth state
				// now that it's actually changed, instead of staying frozen on
				// whatever it read at page load (E24-1).
				EventBus.$emit(E24Event.AUTH_CHANGED)
				this.$router.push({name: 'connect', params: {goodbye: 'TRUE'}})
			})
		}
	},
	computed: {
		isAuthenticated: function () {
			return Vue.e24.security.isAuthenticated()
		}
	}
}
</script>

<style scoped>
/*
 * Logout performs an action (POST /logout + client-side redirect), not
 * navigation to a URL -- it was previously an <a> with no href, which has
 * no link semantics or accessible role. A <button> is correct; this resets
 * only the native button chrome that has no equivalent on an <a> (border,
 * background, cursor, centered text, system font). The rest of the look --
 * color, padding, font-size, the row divider -- comes from the same shared
 * layout.less rules the other (real, hrefed) nav items already use, now
 * extended to also match .linkServices-button.
 */
.linkServices-button {
	border: 0;
	background: none;
	font-family: inherit;
	text-align: left;
	cursor: pointer;
	/* Unlike <a>, a block-level <button> still sizes to its content */
	/* (form controls use shrink-to-fit even at display:block) rather */
	/* than stretching to fill its container -- force it to match. */
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/common/components/login-button.vue